export default {
  INIT: 1,
  // 初始状态
  UPLOAD_READY: 2,
  //  准备上传
  UPLOAD_SUCCESS: 3,
  // 上传结束
  UPLOAD_FAILED: 4,
  // 上传失败
  IMPORTING: 5,
  // 数据正在导入
  IMPORT_SUCCESS: 6,
  // 数据导入成功
  IMPORT_FAILED: 7 // 数据导入失败

};